import React from "react";
import "../style/RangeInput.css";
import { t } from "i18next";

const RangeInput = ({ minValue, maxValue, onMinChange, onMaxChange }) => {
    const handleMinChange = (e) => {
        const inputValue = e.target.value;
        if (inputValue === '' || inputValue === null || inputValue === undefined) {
            onMinChange('');
            return;
        }
        const value = Number(inputValue);
        if (isNaN(value) || value < 0) {
            onMinChange('');
            return;
        }
        const currentMax = maxValue || '';
        if (!currentMax || value <= Number(currentMax)) {
            onMinChange(value);
        }
    };

    const handleMaxChange = (e) => {
        const inputValue = e.target.value;
        if (inputValue === '' || inputValue === null || inputValue === undefined) {
            onMaxChange('');
            return;
        }
        const value = Number(inputValue);
        if (isNaN(value) || value < 0) {
            onMaxChange('');
            return;
        }
        const currentMin = minValue || '';
        if (!currentMin || value >= Number(currentMin)) {
            onMaxChange(value);
        }
    };

    return (
        <div className="range_input_container">
            <div className="range_input_box">
                <span className="label">{t('from')}</span>
                <input
                    type="number"
                    className="range_input"
                    value={minValue || ''}
                    onChange={handleMinChange}
                    placeholder="0"
                    min="0"
                />
            </div>
            <div className="separator"></div>
            <div className="range_input_box">
                <span className="label">{t('to')}</span>
                <input
                    type="number"
                    className="range_input"
                    value={maxValue || ''}
                    onChange={handleMaxChange}
                    placeholder=""
                    min="0"
                />
            </div>
        </div>
    );
};

export default RangeInput;